import userApi from '@/modules/projectA/api/user';
import filingApi from '@/modules/projectA/api/filing';

/**
 * 获取费率信息及在线标志
 * @param {string} companyId - 公司ID
 * @returns {Promise<{showOnlineFlag: boolean, rateNum: number}>}
 */
/* 
  是否开通在线支付
    费率必须大于 0 才校验 
  费率弹窗是 
    不管费率是否大于0都展示, 只要有就行
    先校验如果备案费率有, 不管费率是否大于0都展示服务协议 直接取备案费率
    如果没备案 就校验平台费率 也是同样的 不管费率是否大于0都展示服务协议
*/
export default async function getRateValidate(companyId) {
  const DEFAULT_RESULT = {
    showOnlineFlag: false, // 控制是否开通在线支付, 费率必须大于 0 才校验
    rateNum: 0,
  };

  try {
    // 1. 查询备案费率 备案就是一企一面就是易专采
    const { code: recordCode, data: recordData } = await userApi.queryInquiryRate({ companyId });
    // 有备案, 但备案费率可能为 0
    if (recordCode === '200' && recordData) {
      const { customRate = 0, platformRate = 0 } = recordData;
      const totalRate = Number(customRate) + Number(platformRate);
      return {
        showOnlineFlag: totalRate > 0,
        rateNum: totalRate,
      };
    }

    // 2. 无备案时查询平台费率
    const { code: platformCode, data: platformData = [] } = await filingApi.queryConfigList([
      'chargeNotice.enquiryServiceRate',
    ]);

    if (platformCode === '200' && platformData.length > 0) {
      const platformRate = Number(platformData[0]?.configValue) || 0;
      return {
        showOnlineFlag: platformRate > 0,
        rateNum: platformRate * 10,
      };
    }

    return DEFAULT_RESULT;
  } catch (error) {
    console.error('获取费率信息失败:', error);
    return DEFAULT_RESULT;
  }
}

// 原逻辑保留一份
/* let showOnlineFlag = false;
// 备案登记配置
const baRateRes = await userApi.queryInquiryRate({
  companyId: this.$store.state.USERINFO.companyId,
});
// 先校验备案 在校验平台
if (baRateRes.success && baRateRes.data) {
  //   备案得两个费率和    customRate:客户引入方/备案方比例，小数 ;  platformRate:平台方比例，小数
  const baAllRate = baRateRes.data ? Number(baRateRes.data.customRate) + Number(baRateRes.data.platformRate) : 0;
  showOnlineFlag = baAllRate > 0;
  this.rateNum = baAllRate;
} else {
  // 无备案，校验平台
  // 平台配置
  const ptRateRes = await filingApi.queryConfigList(['chargeNotice.enquiryServiceRate']);
  showOnlineFlag = ptRateRes.success && Number(ptRateRes.data[0].configValue) > 0;
  this.rateNum = Number(ptRateRes.data[0].configValue) * 10;
} */
